import React from 'react';
import cn from 'classnames';

import {IGridProps} from './IGrid';
import {GridColumn, GridRow} from './Subcomponents';

const Grid = (props: IGridProps) => {
	const attrs: {className: string; style?: React.CSSProperties} = {
		className: cn(props.classNames, {
			container: !props.fluid,
			'container-fluid': !!props.fluid,
			[`g-y-${props.verticalGutters}`]: !!props.verticalGutters,
		}),
	};

	if (props.style) {
		attrs.style = props.style;
	}

	return <div {...attrs}>{props.children}</div>;
};

Grid.Row = GridRow;
Grid.Column = GridColumn;

export default Grid;
